import React, { forwardRef, ReactNode } from 'react'
import { Button as MuiButton, ButtonOwnerState, ButtonProps as MuiButtonProps } from '@mui/base/Button'
import clsx from 'clsx'
import classes from './Button.module.scss'

export type ButtonProps = {
  color?: 'primary' | 'neutral' | 'danger' | 'success' | 'warning'
  variant?: 'solid' | 'soft' | 'outlined' | 'plain'
  className?: string
  isActive?: boolean
  isStretched?: boolean
  StartIcon?: ReactNode
  EndIcon?: ReactNode
} & MuiButtonProps

const Button = forwardRef<HTMLButtonElement, ButtonProps>(function CustomButton(
  {
    children,
    StartIcon,
    EndIcon,
    color = 'primary',
    isActive = false,
    isStretched = false,
    variant = 'solid',
    className,
    ...props
  },
  ref
) {
  const slotProps = {
    root: (ownerState: ButtonOwnerState) => ({
      className: clsx(className, classes.root, {
        [classes.primary]: color === 'primary',
        [classes.success]: color === 'success',
        [classes.warning]: color === 'warning',
        [classes.neutral]: color === 'neutral',
        [classes.danger]: color === 'danger',
        [classes.solid]: variant === 'solid',
        [classes.soft]: variant === 'soft',
        [classes.outlined]: variant === 'outlined',
        [classes.plain]: variant === 'plain',
        [classes.disabled]: ownerState.disabled,
        [classes.active]: isActive,
        [classes.stretched]: isStretched,
      }),
    }),
  }

  // Remove useless props that cause react to log errors
  // @ts-ignore
  const {isOpen, ownerState, ...otherProps} = props

  return (
    <MuiButton slotProps={slotProps} ref={ref} {...otherProps}>
      {StartIcon}
      <span>{children}</span>
      {EndIcon}
    </MuiButton>
  )
})

export default Button
